/**
 * @ngdoc component
 * @name  common.product.product-color.component:itxProductColors
 * @requires   ItxUtilsFct,
 * @requires   imProductService, 
 * @requires   ItxSizeGuideSvc
 * @description
 * Product colors component used to list colors for a given product. 
 */
(function() {

    'use strict';

    /**
     * Show category colors
     * @name productColorsCtrl
     * @type ItxProductColorsCmpCtrl
     */
    var ItxProductColorsCmp = {
        bindings: {
            product: '<',
            selectedColor: '<',
            colorsCount: '<',
            clickChangeColor: '&'
        },
        controller: ItxProductColorsCmpCtrl,
        templateUrl: 'ItxProductColors.html'
    };

    angular.module('itxApp.common')
        .component('itxProductColors', ItxProductColorsCmp);

    ItxProductColorsCmpCtrl.$inject = [
        'ItxUtilsFct', 
        'imProductService'
    ];

    function ItxProductColorsCmpCtrl(
        ItxUtilsFct, 
        imProductService
    ) {
        var _this = this;
        _this.colors = [];

        _this.$onInit = function() {
            let colors = _.filter(_this.product.activeDetail.colors, function(color){
                return color.visibility != 'hidden';
            });
            _this.colors = colors.slice(0,_this.colorsCount);
        };

        _this.getProductImageUrls = function(color) {
            var imageUrl = '';
            if (color.image && inditex.iStoreJSON.details.xmedia !== null) {
                imageUrl = ItxUtilsFct.getImageProductUrls(_this.product.activeDetail, color.id, 'colorcut', 'color', 'color')[0];
            }
            return imageUrl;
        };

        _this.changeColor = function(color) {
            if (_this.selectedColor.id !== color.id) {                
                _this.clickChangeColor({
                    color: color
                });
                imProductService.eventSelectColor(_this.product, color.id);
            }
        };

    }

})();